import { AVideoProps } from '../../atoms/AVideo/AVideo.types';
import { MButtonOverlayProps } from '../MButtonOverlay/MButtonOverlay.types';

export enum MVideoBackgroundButtonPosition {
  Bottom = 'Bottom',
  Top = 'Top',
}

export interface MVideoBackgroundProps {
  buttonPosition?: MVideoBackgroundButtonPosition;
  aVideo: AVideoProps;
  mButtonOverlay?: MButtonOverlayProps & {
    imageOverlay?: 'True' | 'False' | boolean;
  };
  className?: string;
}

export type MVideoBackgroundButtonPositionType = MVideoBackgroundButtonPosition;
